import React from 'react';
import { Popup, Cell, Button, Picker, Toast } from 'zarm';
import ReactEcharts from 'echarts-for-react';
import moment from 'moment';
import './index.less';


class Table extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
        const { dataSource = [], columns = [] } = this.props;
        return <div className="tabel_container">
            <table>
                <thead>
                    <tr>
                        {
                            columns.map((col) => {
                                return <th>{col.title}</th>
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        dataSource.length ? dataSource.map((item) => {
                            return <tr>
                                {
                                    columns.map((col) => {
                                        const value = item[col.key];
                                        return <td>{col.key === 'examDate' ? <span>{moment(+value * 1000).format('YYYY-MM-DD')}</span> : value}</td>
                                    })
                                }
                            </tr>
                        }) : <tr><td colSpan={columns.length} style={{ textAlign: 'center' }}>暂无数据</td></tr>
                    }
                </tbody>
            </table>
        </div>
    }
}

export default Table;
